import React from 'react';
import styled from 'styled-components/macro';
import { themeColors } from '../../theme/theme';
import { FlexRow } from '../basic/Flex';
import { Body2 } from './Text';
import { Button } from './buttons';
import { useMessageGetter } from 'react-message-context';

const PaginationList = styled.ul`
  display: flex;
  flex-direction: row;
  gap: 4px;
  list-style: none;
  margin: 0;
  padding: 8px;
  background: ${themeColors.charcoal};
  border-radius: 35px;
`;
const PaginationListItem = styled.li`
  list-style: none;
`;

const PaginationButton = styled(Button)`
  height: 40px;
  width: 40px;
  background: none;
  cursor: pointer;
  border: none;
  border-radius: 35px;
  color: ${themeColors.white};

  &.active {
    border: 2px solid ${themeColors.white};
  }
`;

const PaginationIconButton = styled(PaginationButton)`
  padding: 0;

  svg {
    height: 16px;
    width: 16px;
  }
`;

type Props = {
  currentPage: number;
  numberOfPages: number;
  handlePageChange: (pageNumber: number) => void;
};

const Pagination: React.FC<Props> = ({ currentPage, numberOfPages, handlePageChange }) => {
  const t = useMessageGetter('pagination');

  return (
    <FlexRow padding="40px 0" justifyContent="center">
      <nav>
        <PaginationList>
          <PaginationIconButton
            icon="arrowBackward"
            primary
            onClick={() => handlePageChange(currentPage - 1)}
            aria-label={t('previousPage')}
          />
          {Array.from({ length: numberOfPages }, (_, index) => {
            const page = index + 1;
            return (
              <PaginationListItem key={page}>
                <PaginationButton
                  className={page === currentPage ? 'active' : ''}
                  onClick={() => handlePageChange(page)}
                  aria-label={t('pageNumber', { page })}
                >
                  <Body2 $color={themeColors.white}>{page}</Body2>
                </PaginationButton>
              </PaginationListItem>
            );
          })}
          <PaginationIconButton
            icon="arrowForward"
            primary
            onClick={() => handlePageChange(currentPage + 1)}
            aria-label={t('nextPage')}
          />
        </PaginationList>
      </nav>
    </FlexRow>
  );
};

export default Pagination;
